module.exports = __webpack_public_path__ + "img/500.5b688b46.svg";